<template>
  <div id="new_title">
    <div class="new_title_wrapper">
      <img src="../assets/title_icon.png" alt="" />
      <p>{{ title }}</p>
      <img src="../assets/title_icon.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "newTitle",
  props: {
    title: {
      type: String,
      default: "title",
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#new_title {
  width: 100%;
  display: flex;
  justify-content: center;
  .new_title_wrapper {
    display: flex;
    align-items: center;
    gap: 30px;
    img {
      width: 28px;
      height: 28px;
      display: block;
    }
    p {
      font-size: 30px;
      font-weight: 600;
    }
  }
}
@media only screen and (max-width: 1280px) {
  #new_title {
    .new_title_wrapper {
      gap: 16px;
      img {
        width: 20px;
        height: 20px;
        display: block;
      }
      p {
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  #new_title {
    .new_title_wrapper {
      gap: 16px;
      img {
        width: 20px;
        height: 20px;
        display: block;
      }
      p {
        font-size: 24px;
        font-weight: 600;
      }
    }
  }
}
</style>